// Colors
export const GRAY = '#e1e4eb';
export const LIGHT_GRAY = '#EAF6FB';
export const LIGHTER_GRAY = '#FAFAFA';
export const GRAY_TEXT = '#2C373D';
export const GRAY_WHITE = '#F1F1F1';
export const WHITE = '#FFFFFF';
export const BLUE = '#25a0d4';
export const PURPLE = '#B6B0E8';
export const DARK_PURPLE = '#453D72';
export const RED = '#cc0006';
export const MAIN_GRAY = '#E8EDF4';
export const PLACEHOLDER_GRAY = '#7c8495';
export const LINK = '#1976d2';

export const BACKDROP_LIGHT = 'rgba(245, 242, 249, 0.8)';
export const BACKDROP_DARK = undefined;

export const colors = {
  GRAY: '#e1e4eb',
  LIGHT_GRAY: '#EAF6FB',
  LIGHTER_GRAY: '#FAFAFA',
  GRAY_TEXT: '#2C373D',
  BLACK_TEXT: '#1c2129',
  GRAY_WHITE: '#F1F1F1',
  WHITE: '#FFFFFF',
  BLUE: '#25a0d4',
  PURPLE: '#B6B0E8',
  DARK_PURPLE: '#453D72',
  RED: '#cc0006',
  MAIN_GRAY: '#E8EDF4',
  PLACEHOLDER_GRAY: '#7c8495',
  TEAL_LIGHT: '#e6fffb',
  TEAL: '#78e5da',
  TEAL_DARK: '#21c6c5',
  GREEN: '#48d2a0',
  GOLDEN_YELLOW: 'rgba(249, 210, 118, 0.5)',
};

export const alert = {
  gray: 'rgba(215, 217, 224, 0.4)',
  red: 'rgba(243, 28, 30, 0.2)',
  yellow: 'rgba(249, 210, 118, 0.2)',
  orange: '#F4976F',
};

export const blue = {
  200: '#A9C6FF',
  300: '#9AC9FF',
  400: '#5C93C4',
  500: '#384B60',
  600: '#F8F8F8',
  700: '#262E5C',
  800: '#18ABCB',
};

export const cherry = {
  200: '#FDC2BA',
  300: '#FAA796',
  400: '#DB565D',
  500: '#931E4D',
};

export const common = {
  black: '#000',
  white: '#fff',
};

export const error = {
  main: '#FB4E4E',
  100: '#FF676820',
};

export const gray = {
  100: '#FAFAFB',
  200: '#F5F6F8',
  300: '#F1F1F4',
  400: '#ECECF1',
  500: '#E6E7EC',
  600: '#D7D9E0',
  700: '#757A96',
  800: '#4D5378',
  900: '#66788A',
  1000: '#868686',
  1100: '#8A8A8A',
  1200: '#F4F2F9',
};

export const green = {
  100: '#64D5A4',
  200: '#A0E19533',
  300: '#4CB400',
  400: '#009900',
  500: '#71C55B',
  600: '#92E27A',
};

export const info = {
  main: '#9AC9FF',
};

export const orange = {
  100: '#F4976F',
  200: '#EF7F18',
};

export const profiles = {
  conservador: '#38A703',
  conservarOld: '#6582F7',
  moderado: '#B5D203',
  crecimiento: '#F2F200',
  balanceado: '#CB22E2',
  agresivo: '#FFBC43',
  extremo: '#D8131A',
};

export const purple = {
  200: '#B99BC2',
  300: '#F3EBF1',
  400: '#6654A8',
  500: '#30245B',
  600: '#6D46DD',
  700: '#DED4F1',
};

export const red = {
  100: '#F31C1E',
  200: '#FF6768',
  300: '#FF676833',
};

export const success = {
  main: '#33D69F',
  100: '#A0E195',
  200: '#2AC769',
};

export const warning = {
  main: '#F6A609',
};

export const paletteBase = {
  alert,
  blue,
  cherry,
  common,
  error,
  gray,
  green,
  info,
  orange,
  profiles,
  purple,
  red,
  success,
  warning,
};

export const black = {
  main: '#1E232B',
  100: '#101419',
  200: 'rgba(255, 255, 255, 0.08)', // hover
  300: '#3c4444', // hover
};
